import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-membership-success-page',
  templateUrl: './change-membership-success-page.component.html',
  styleUrls: ['./change-membership-success-page.component.scss']
})
export class ChangeMembershipSuccessPageComponent implements OnInit {

  constructor() { }

  message: string = '';
  
  ngOnInit() {
  }

}
